export { ForgotPasswordModal } from './ForgotPasswordModal.component';
